import getFormFieldSchema from 'checkout/lib/utils/form/getFormFieldSchema'

/**
 * Display titles for flight passenger name fields, aligned with svc-flights passenger titles
 * (mr, mrs, ms, miss, mstr, dr). Schema enums may use any casing.
 */
const LOWERCASE_TO_DISPLAY: Record<string, string> = {
  mr: 'Mr',
  mrs: 'Mrs',
  ms: 'Ms',
  miss: 'Miss',
  mstr: 'Master',
  master: 'Master',
  dr: 'Dr',
}

export function normalizeFlightPassengerDisplayTitle(raw: string | undefined): string {
  if (!raw) {
    return ''
  }
  const trimmed = raw.trim()
  const mapped = LOWERCASE_TO_DISPLAY[trimmed.toLowerCase()]
  if (mapped) {
    return mapped
  }
  return trimmed
}

/** Builds title dropdown options from the traveller schema enum (order preserved; casing normalised). */
export function passengerTitleOptionsFromSchemaEnum(schemaEnum: unknown): Array<string> {
  if (!Array.isArray(schemaEnum)) {
    return []
  }
  return schemaEnum
    .map(v => normalizeFlightPassengerDisplayTitle(String(v)))
    .filter(Boolean)
}

/** True when this traveller has a flight name field whose title enum does not include Dr. */
export function flightTravellerSchemaExcludesDr(formSchema: App.Checkout.FormSchema, travellerId: string): boolean {
  const travellerSchema = formSchema.properties[travellerId]
  if (!travellerSchema?.properties) {
    return false
  }
  for (const fieldId of Object.keys(travellerSchema.properties)) {
    const fieldSchema = getFormFieldSchema(travellerSchema, fieldId, formSchema)
    if (fieldSchema?.type !== 'flightPassengerNameField' || !fieldSchema.subFields) {
      continue
    }
    const titleField = fieldSchema.subFields.title as { enum?: unknown }
    if (!titleField.enum) {
      continue
    }
    const allowed = new Set(passengerTitleOptionsFromSchemaEnum(titleField.enum))
    return allowed.size > 0 && !allowed.has('Dr')
  }
  return false
}
